import { createSlice } from '@reduxjs/toolkit';
import { CartState } from 'store/cart/types';
import setCartActiveSelectorReducer from './reducer/setCartActiveSelectorReducer';
import setCartOrderItemIdFetchingReducer from './reducer/setCartOrderItemIdFetchingReducer';
import setCartItemReducer from './reducer/setCartItemReducer';
import setCartItemsFetchingReducer from './reducer/setCartItemsFetchingReducer';
import setCartItemsReducer from './reducer/setCartItemsReducer';
import setCartReducer from './reducer/setCartReducer';
import setCartTotalFetchingReducer from './reducer/setCartTotalFetchingReducer';
import setCartVouchersReducer from './reducer/setCartVouchersReducer';

export const basketInitialState: CartState = {
  isCartFetching: false,
  isCartTotalFetching: false,
  isCartItemsFetching: false,
  cartOrderItemIdFetching: 0,
  activeSelector: undefined,
  cart: undefined,
};

export const slice = createSlice({
  name: 'basket',
  initialState: basketInitialState,
  reducers: {
    setCartTotalFetchingAction: setCartTotalFetchingReducer,
    setCartItemsFetchingAction: setCartItemsFetchingReducer,
    setCartOrderItemIdFetchingAction: setCartOrderItemIdFetchingReducer,
    setCartAction: setCartReducer,
    setCartItems: setCartItemsReducer,
    setCartItem: setCartItemReducer,
    setCartTotals: setCartReducer,
    setCartVouchers: setCartVouchersReducer,
    setCartActiveSelector: setCartActiveSelectorReducer,
  },
});

export const {
  setCartTotalFetchingAction,
  setCartItemsFetchingAction,
  setCartOrderItemIdFetchingAction,
  setCartAction,
  setCartItems,
  setCartItem,
  setCartTotals,
  setCartVouchers,
  setCartActiveSelector,
} = slice.actions;

const app = slice.reducer;
export default app;
